import script from "./mark-ignored-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./mark-ignored-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./mark-ignored-dialog.vue?vue&type=style&index=0&id=7ca64206&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ca64206"]])

export default __exports__